class FetchAccountFacilities {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAccountFacilities;
